import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Hero from "@/components/Hero";
import { Intro } from "@/sections/Intro";
import { Capabilities } from "@/sections/Capabilities";
import { Connected } from "@/sections/Connected";
import { Materials } from "@/sections/Materials";
import { Quality } from "@/sections/Quality";
import { Applications } from "@/sections/Applications";
import { Facilities } from "@/sections/Facilities";
import { Process } from "@/sections/Process";
import { Faq } from "@/sections/Faq";
import { FinalCta } from "@/sections/FinalCta";
import { Contact } from "@/sections/Contact";
import { Footer } from "@/components/Footer";
import { BottomNav } from "@/components/BottomNav";
import { FloatingControls } from "@/components/FloatingControls";
import { AiAssistant } from "@/components/AiAssistant";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <main className="bg-[#070A0F]">
      <Hero />
      <Intro />
      <Capabilities />
      <Connected />
      <Materials />
      <Quality />
      <Applications />
      <Facilities />
      <Process />
      <Faq />
      <FinalCta />
      <Contact />
      <Footer />
      <BottomNav />
      <FloatingControls />
      <AiAssistant />
    </main>
  );
}

export default App;
